/**
 * Checkout must not flash “Your shopping cart is empty” while the
 * pending-order-summary request is still in flight (loading starts false).
 */

export function shouldShowCheckoutLoading({
  loading = false,
  summary = null,
  error = null,
} = {}) {
  if (error) return false
  if (loading) return true
  return summary == null
}

export function shouldShowCheckoutEmptyBasket({
  loading = false,
  summary = null,
  error = null,
} = {}) {
  if (shouldShowCheckoutLoading({ loading, summary, error })) return false
  if (error) return false
  const suppliers = summary?.suppliers
  return !Array.isArray(suppliers) || suppliers.length === 0
}
